import { SubmitFlow } from "@/components/submit/SubmitFlow";

export function SubmitPage() {
  return <SubmitFlow />;
}
